import { DeepLinkActions, EDeepLinkActions } from "@edp-store/actions/deep-link.actions";
import { IDeepLinkState, initialDeepLinkState } from "@edp-store/state/deep-link.state";

export function deepLinkReducers(state = initialDeepLinkState, action: DeepLinkActions): IDeepLinkState {
    switch (action.type) {
        case EDeepLinkActions.SetDeepLink: {
            return {
                ...state,
                deepLink: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
